<template>
  <v-container fluid>
    <v-row dense>
      <v-col v-for="provider in providers" :key="provider.code" cols="6">
        <v-card>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="headline">{{ provider.name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-img :src="provider.img" class="white--text align-end" gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)" height="200px" />

          <v-card-actions>
            <v-btn color="orange" text @click="seeGames(provider)">
              See games
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

export default {
  computed: {
    token() {
      return this.$store.state.login.token;
    },
    logged() {
      return this.$store.state.login.logged;
    },
    providers() {
      return this.$store.state.providers || [];
    },
  },
  methods: {
    seeGames(provider) {
      this.$store.dispatch('setProvider', provider);
      this.$router.push({ name: 'games', params: { provider: provider.id } })

    }, 
  }
}
</script>
